import { createSlotRecipe } from './runtime';

const drawerConfig = {"name":"drawer","slots":["trigger","backdrop","positioner","content","title","description","closeTrigger","header","body","footer"],"defaultVariants":{"variant":"right"},"variantMap":{"variant":["left","right"]}}

export const drawer = /* @__PURE__ */ createSlotRecipe(drawerConfig)